import { isEqual } from 'lodash';
import React, { useContext, useState } from 'react';
import { RicosContext, ModalContext, EditorContext, PluginsEventsContext } from 'ricos-context';
import { SidePanelLayout, FooterActions } from 'wix-rich-content-ui-components';
import { CollapsibleListSettings } from '../components/modal-components/CollapsibleListSettings.js';
import { collapsibleModals } from '../consts.js';
import { MODAL_ROOT } from '../dataHooks.js';
import { COLLAPSIBLE_LIST_TYPE } from '../types.js';
import '@wix/design-system';
import 'wix-rich-content-plugin-commons';
import '../style-inject.es-e7b07dd7.js';
import '@tiptap/pm/state';
import 'ricos-types';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const CollapsibleListSettingsModal = ({ nodeId, isQapageDataEnabled }) => {
  const { t, languageDir } = useContext(RicosContext);
  const modalService = useContext(ModalContext) || {};
  const {
    adapter: { tiptapEditor },
    getEditorCommands
  } = useContext(EditorContext);
  const pluginsEvents = useContext(PluginsEventsContext);
  const [initialComponentData] = useState(
    () => getEditorCommands().getBlockComponentData(nodeId)
  );
  const fromComponentData = (componentData) => {
    const textDirectionToList = (textDirection) => {
      if (textDirection === "rtl") {
        return "RTL";
      }
      return "LTR";
    };
    return {
      initialExpanded: componentData.initialExpandedItems === "ALL" ? {
        type: "ALL"
      } : {
        type: componentData.initialExpandedItems,
        expandOnlyOne: componentData.expandOnlyOne
      },
      direction: (componentData == null ? void 0 : componentData.direction) || textDirectionToList(languageDir),
      isQapageData: !!componentData.isQapageData
    };
  };
  const toComponentData = (settings2, originalComponentData) => ({
    containerData: originalComponentData.containerData,
    expandOnlyOne: settings2.initialExpanded.type === "ALL" ? false : settings2.initialExpanded.expandOnlyOne,
    initialExpandedItems: settings2.initialExpanded.type,
    direction: settings2.direction,
    isQapageData: settings2.isQapageData
  });
  const toListAttributes = (value) => ({
    expandOnlyOne: value.initialExpanded.type === "ALL" ? false : value.initialExpanded.expandOnlyOne,
    initialExpandedItems: value.initialExpanded.type
  });
  const [settings, setSettings] = useState(
    () => fromComponentData(initialComponentData)
  );
  const pluginEvents = {
    onChangePluginSettings: (data) => pluginsEvents.publishPluginChangeSettings(__spreadProps(__spreadValues({}, data), { nodeId }))
  };
  const setCollapsibleListComponentData = (data) => {
    getEditorCommands().setBlock(nodeId, COLLAPSIBLE_LIST_TYPE, data);
  };
  const handleChange = (value) => {
    setSettings(value);
    setCollapsibleListComponentData(toComponentData(value, initialComponentData));
    tiptapEditor.chain().focus().setCollapsibleListAtributes(nodeId, toListAttributes(value));
  };
  const closeModal = () => {
    modalService.closeModal(collapsibleModals.settings);
  };
  const handleCancel = () => {
    const initialSettings = fromComponentData(initialComponentData);
    if (!isEqual(initialSettings, settings)) {
      handleChange(initialSettings);
    }
    closeModal();
  };
  return settings ? /* @__PURE__ */ React.createElement(
    SidePanelLayout,
    {
      onCloseButtonClick: handleCancel,
      dataHook: MODAL_ROOT,
      header: { title: t("CollapsibleList_CollapsibleListSettings_Common_Header") },
      content: {
        children: /* @__PURE__ */ React.createElement(
          CollapsibleListSettings,
          {
            value: settings,
            onChange: handleChange,
            pluginEvents,
            isQapageDataEnabled
          }
        )
      },
      footer: { children: /* @__PURE__ */ React.createElement(FooterActions, { onCancel: handleCancel, onSave: closeModal }) }
    }
  ) : null;
};

export { CollapsibleListSettingsModal as default };
//# sourceMappingURL=SettingsModals.js.map
